export enum PriorityTypes {
  very_low = 'Low',
  low = 'Very Low',
  medium = 'Medium',
  high = 'High',
  very_high = 'Very High',
}
